var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"container",staticClass:"legend-container"},[_c('svg',{ref:"svg",staticClass:"overflow-visible fill-current"})])
}
var staticRenderFns = []

export { render, staticRenderFns }